import { useAppSelector } from 'app-redux/hooks'
import { selectStacks } from 'app-redux/deck/selectors'

import ListCard from 'components/card/deckCards/listCard'
import StackWrapper from 'components/deckPage/dragAndDrop/StackWrapper'
import StackHeader from 'components/deckPage/DeckContainerV2/StackHeader'
// import StickiedDeckControls from 'components/deckPage/filtersAndControls/StickiedDeckControls'

import { useCategoryIsCollapsed } from 'hooks/collapsibleCategories'

import { StackType } from 'types/deck'

import styles from './list.module.scss'

const ListLayout = () => {
  const { mainDeck, sideDeck } = useAppSelector(selectStacks)

  const displaySections = [...mainDeck, ...sideDeck]

  return (
    <div className={styles.container}>
      {/* <StickiedDeckControls /> */}

      {displaySections.map((stack, index) => (
        <List stack={stack} key={index} />
      ))}
    </div>
  )
}

type ListProps = {
  stack: StackType
  className?: string
}

const List = ({ stack }: ListProps) => {
  const isCollapsed = useCategoryIsCollapsed(stack.name)

  return (
    <StackWrapper name={stack.name}>
      <div className={styles.stackHeaderContainer}>
        <StackHeader
          className={styles.stackHeader}
          name={stack.name}
          quantity={stack.quantity}
          mdfcQuantity={stack.mdfcQuantity}
          price={stack.price}
          cardIds={stack.cardIds}
          includeInDeck={stack.includedInDeck}
          includeInPrice={stack.includedInPrice}
          isPremier={stack.isPremier}
        />
      </div>

      <div className={styles.cardList}>
        {!isCollapsed && stack.cardIds.map(cardId => <ListCard stackName={stack.name} key={cardId} cardId={cardId} />)}
      </div>
    </StackWrapper>
  )
}

export default ListLayout
